export default __webpack_public_path__ + "static/media/logo_white.8dcf681e.svg";